import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import RefreshIcon from '@mui/icons-material/Refresh';

function SWWPage() {
  const handleClick = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{ flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <SentimentVeryDissatisfiedIcon sx={{ fontSize: 164, color: 'grey.600' }} />
      <Typography variant="h5" mb={1}>
        <FormattedMessage id="title" defaultMessage="Something went wrong..." />
      </Typography>
      <Typography variant="body1" mb={4} color="grey.600">
        <FormattedMessage
          id="subtitle"
          defaultMessage="The server did not provide the necessary data. Please refresh the page."
        />
      </Typography>
      <Button startIcon={<RefreshIcon />} onClick={handleClick}>
        <FormattedMessage id="button" defaultMessage="Refresh the Page" />
      </Button>
    </Container>
  );
}

export default SWWPage;
